import { Box, Container, Typography } from "@mui/material";
import React from "react";
import awareness1 from "../../images/awareness1.png";

const styles = {
  parenBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px",
    mt:"40px"
  },
  leftBox: {
    display: "flex",
    alignItems: "start",
    justifyContent: "center",
    flexDirection: "column",
    gap: 3,
    flexWrap: "wrap",
  },
  rightBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroTitle: {
    fontFamily: "poppins",
    fontWeight: "bold",
    lineHeight: 1.5,
    opacity: 0.7,
  },
  heroSubtitle: {
    fontFamily: "poppins",
    fontWeight: 600,
    opacity: 0.7,
  },
  button: {
    px: "10px",
    py: "5px",
    fontFamily: "poppins",
    fontSize: "14px",
    textTransform: "none",
    backgroundColor: "#141414FF",
    color: "#ffffff",
  },
};

const AwarenessHero = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ ...styles.parenBox }}>
        <Box sx={{ ...styles.leftBox }}>
          <Typography
            variant="h4"
            textAlign={"start"}
            sx={{ ...styles.heroTitle }}
          >
            Understanding Awareness: <br /> A Journey Within
          </Typography>
          <Typography
            variant="body1"
            textAlign="start"
            sx={{ ...styles.heroSubtitle }}
          >
            Awareness, a term often used interchangeably with consciousness, is
            the fundamental human capacity to perceive, feel, and think. It’s
            the silent observer, the ever-present witness to the tapestry of our
            experiences. It is the foundation of all meditation and also the
            goal of all meditations.
          </Typography>
        </Box>

        <Box sx={{ ...styles.rightBox }}>
          <Box
            component="img"
            src={awareness1}
            sx={{ width: "550px", heigh: "500px", borderRadius: "50px" }}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default AwarenessHero;
